import {
  HOME_ROUTE,
  LOGIN_DOMINICANA_ROUTE,
  LOGIN_MULTIMARCA_ROUTE,
  LOGIN_TIRAYGANA_ROUTE,
  LOGIN_TASTETHEWIN_ROUTE,
  LOGIN_SABOREALAADRENALINA_ROUTE,
  LOGIN_ROUTE,
} from '../../providers/routes'
import { parseEnvFields } from '../../utils/utils'

const requiredUserFields = parseEnvFields(
  process.env.SESSION_REQUIRED_USER_FIELDS,
)

export const authStorageConfig = {
  name: 'authValidation',
  publicPaths: [
    HOME_ROUTE,
    { path: LOGIN_ROUTE, exact: false },
    { path: LOGIN_DOMINICANA_ROUTE, exact: false },
    { path: LOGIN_MULTIMARCA_ROUTE, exact: false },
    { path: LOGIN_TIRAYGANA_ROUTE, exact: false },
    { path: LOGIN_TASTETHEWIN_ROUTE, exact: false },
    { path: LOGIN_SABOREALAADRENALINA_ROUTE, exact: false },
  ],
  storages: [
    {
      key: 'pushMoneyUser',
      dataPath: 'user',
      tokenPath: 'token',
      requiredFields: requiredUserFields,
      additionalKeys: ['timeStampAuth'],
    },
  ],
  onFailure: {
    redirect: LOGIN_ROUTE,
  },
}

export default authStorageConfig
